import produce from "immer";

/**
 * Return a unique array of primitive members
 * Sorts the array
 * @private
 */
export function arrayUnique<T>(array: T[]): T[] {
  return array.sort().filter((item, pos, ary) => !pos || item !== ary[pos - 1]);
}

// alphabetic sort callback
export const alphabetically = (a, b) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

export const removeStr = (arr: string[], element: string): string[] =>
  produce(arr, (draft) => {
    if (!Array.isArray(draft)) {
      return arr;
    }
    const index = draft.indexOf(element, 0);
    if (index > -1) {
      draft.splice(index, 1);
    }
    return draft;
  });
